import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.AfterNavigateCareers,
  {
    key: LocationVarKey.AfterNavigateCareers1,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.HasCareerURL, "1"),
      IS_NOT_EQUAL(LocationVarKey.AfterNavigateCareers, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
    ])
  },
  {
    key: LocationVarKey.AfterNavigateCareers2,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.HasCareerURL, "1"),
      IS_NOT_EQUAL(LocationVarKey.AfterNavigateCareers, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
    ])
  }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Careers
      </PageHeader>

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasCareerURL, "1")}>
        <SwitchRow {...page} keyName={LocationVarKey.AfterNavigateCareers} label="Ask if they want to be navigated to your Careers URL" />
        <Section
          {...page}
          hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.AfterNavigateCareers, "1"), IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")])}
        >
          <SectionHeader {...page}> After Navigate</SectionHeader>
          <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AfterNavigateCareers1} />
          <TextAreaRow
            {...page}
            marginTop
            label=" Message 2 (Optional)"
            keyName={LocationVarKey.AfterNavigateCareers2}
            enableSwitchVar={LocationVarKey.AfterNavigateCareers2Enabled}
          />
        </Section>
      </Section>
    </>
  );
}
